"use client";

import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { ArrowLeft } from "lucide-react";
import { CockpitPageHeader } from "@/components/cockpit/CockpitPageHeader";
import { getMyModuleTimeline } from "@/lib/modules.functions";
import { IDEA_POOL_INTRO } from "@/lib/module-ideas";
import { ModuleIdeaBoard } from "@/components/cockpit/ModuleIdeaBoard";

export const Route = createFileRoute("/_cockpit/cockpit/hundert-tage/ideen")({
  head: () => ({
    meta: [
      { title: "Ideenpool – 100 Tage im Amt – Cockpit – creategy" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: IdeenRoute,
});

/** Ticket Z8: Ideenpool des Moduls „100 Tage im Amt". */
function IdeenRoute() {
  const fetchTimeline = useServerFn(getMyModuleTimeline);
  // Die Zeitachse liefert die aktuelle oder rechnerische Phase; sie steuert nur
  // die Reihenfolge der Anzeige, nie die Sichtbarkeit.
  const { data } = useQuery({
    queryKey: ["cockpit", "hundert-tage", "timeline"],
    queryFn: () => fetchTimeline(),
  });

  return (
    <div className="space-y-6">
      <div>
        <Link
          to="/cockpit/hundert-tage"
          className="inline-flex items-center gap-1 text-sm font-semibold text-primary hover:underline"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden />
          Zurück zur Übersicht
        </Link>
        <div className="mt-3">
          <CockpitPageHeader title="Ideenpool" description={IDEA_POOL_INTRO} />
        </div>
      </div>

      <ModuleIdeaBoard currentPhase={data?.markerPhaseKey ?? null} />
    </div>
  );
}
